// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-button[data-v-9d1d6e94]{font-family:Exo\\ 2,sans-serif;font-size:.875rem;line-height:1.25rem;font-weight:600;line-height:19px;letter-spacing:-.01em;--tw-text-opacity:1;color:rgba(47,43,49,var(--tw-text-opacity));text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
